module.exports = __webpack_public_path__ + "static/media/EMS.76d74708.png";